import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { SymbolClientTranslator } from '../symbolClient.translator';
import { SymbolClientAction } from '../symbolClient.action';

type IDependencies = IClientApiDependencySegment;

export const loadSymbolClientEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(SymbolClientAction.load.started),
  mergeMap((params) => {

    if ('serverId' in params) {
      const { serverId, name: clientSymbolName } = params;
      return dependencies.api.getServerClientSymbolDetails({ serverId, clientSymbolName }).pipe(
        mergeMap((response) => {
          return [
            SymbolClientAction.load.done({
              params,
              result: SymbolClientTranslator.fromServerDetailsApi(response),
            }),
          ];
        }),
        catchApiError((error) => {
          return [
            SymbolClientAction.load.failed({ params, error }),
            createApiErrorNotification(error),
          ];
        }),
      );
    } else {
      const { nodeId, name: clientSymbolName } = params;
      return dependencies.api.getNodeClientSymbolDetails({ nodeId, clientSymbolName }).pipe(
        mergeMap((response) => {
          return [
            SymbolClientAction.load.done({
              params,
              result: SymbolClientTranslator.fromNodeDetailsApi(response),
            }),
          ];
        }),
        catchApiError((error) => {
          return [
            SymbolClientAction.load.failed({ params, error }),
            createApiErrorNotification(error),
          ];
        }),
      );
    }
  }),
);
